import { AuthService } from './auth.service';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login.routing.module';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from "ngx-spinner";
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [LoginRoutingModule, FormsModule, CommonModule, NgxSpinnerModule, SharedModule],
    declarations: [],
    providers: [AuthService]
})

export class LoginModule { }
